import { couponSortsAtom, CouponSort, CouponSortTab } from '@activities/membership/coupon/CouponActivity/atoms/couponAtoms';
import BottomSheetHeader from '@components/BottomSheetHeader';
import Column from '@components/Column';
import Radio from '@components/Radio';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { BottomSheet } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

interface Params {
    tab: CouponSortTab;
}

declare module '@stackflow/config' {
    interface Register {
        CouponSortBottomSheet: Params;
    }
}

const SORTS: CouponSort[] = ['registered', 'closingSoon'];

/** 쿠폰 목록 정렬 선택. 선택하는 즉시 해당 탭의 목록에 반영한다. */
const CouponSortBottomSheet: ActivityComponentType<'CouponSortBottomSheet'> = ({ params }) => {
    const { t } = useTranslation('coupon');
    const { tab } = params;
    const [sorts, setSorts] = useAtom(couponSortsAtom);
    return (
        <BottomSheet>
            <BottomSheetHeader>
                {t('filter.title')}
            </BottomSheetHeader>
            <Container spacing={2} fullWidth>
                <Text fontWeight='bold'>{t('filter.sortLabel')}</Text>
                <Column fullWidth>
                    {SORTS.map((sort) => (
                        <RadioWrapper key={sort}>
                            <Radio value={sort}
                                isSelected={sorts[tab] === sort}
                                onChange={() => setSorts((prev) => ({ ...prev, [tab]: sort }))}>
                                {t(`filter.${sort}`)}
                            </Radio>
                        </RadioWrapper>
                    ))}
                </Column>
            </Container>
        </BottomSheet>
    );
};

const Container = styled(Column)`
    padding: var(--spacing-4) var(--spacing-4) calc(var(--spacing-4) + var(--safe-area-bottom));
`;

const RadioWrapper = styled.div`
    padding: var(--spacing-2) 0;
    width: 100%;
`;

export default CouponSortBottomSheet;
